import { useAuth } from '../auth/AuthContext'

/**
 * 閲覧専用（viewerロール）ユーザーのホーム。
 * viewerは通常アプリ（一覧・TODO等）を持たず、共有された議事録リンクから
 * サマリのみ閲覧できる（ViewerDocumentPage）。
 */
export function ViewerHomePage() {
  const { user, signOut } = useAuth()

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--color-surface, #f5f6f8)', padding: 16 }}>
      <div className="card" style={{ maxWidth: 440, width: '100%', padding: 'var(--space-8, 32px)', textAlign: 'center' }}>
        <div style={{ fontFamily: 'var(--font-brand)', fontSize: 28, fontWeight: 700, letterSpacing: '0.02em', marginBottom: 16 }}>
          BluePaper
        </div>
        <span className="badge badge-neutral" style={{ marginBottom: 16 }}>閲覧専用アカウント</span>
        <p className="text-sm text-secondary" style={{ marginBottom: 8 }}>
          このアカウントは議事録の閲覧専用です。
        </p>
        <p className="text-sm text-secondary" style={{ marginBottom: 24 }}>
          共有された議事録のリンクを開くと、そのサマリを閲覧できます。
        </p>
        <div className="text-xs text-tertiary" style={{ marginBottom: 24 }}>{user?.email}</div>
        <button className="btn btn-outline btn-sm" onClick={() => signOut()}>
          ログアウト
        </button>
      </div>
    </div>
  )
}
